export default __webpack_public_path__ + "f84b476995a8496adce24ec672244eafc9a43686/4bca7c828ddf6f2ef86681e533b2f019.png";